import { DesignStudioParametersToolkit, Loader } from "@tfg/ui"
import { useEffect, useState } from "react"
import { useSearchParams, useParams } from "react-router-dom"
import z from "zod"

import { ScopedConfigurationsResponse } from "@tfg/types/types/communication-studio/configurations.types"
import { StylingParameters } from "@tfg/types/types/communication-studio/styling-parameters.types"

import { i18n } from "~/i18n"
import { ProductSheetGroup } from "~/pages/Brand/CommunicationStudio/contexts/productSheetGroup/ProductSheetGroupContext"
import { SearchEngine } from "~/pages/Public/SearchEngine"

const EventTypesSchema = z.enum([
  "STYLE_DATA",
  "CONFIGURATION_DATA",
  "PRODUCT_SHEET_GROUP",
])

export const SearchEnginePreview = () => {
  const [styleData, setStyleData] = useState<StylingParameters | null>(null)
  const [configuration, setConfiguration] =
    useState<ScopedConfigurationsResponse | null>(null)
  const [searchParams, setSearchParams] = useSearchParams()
  const { slug } = useParams()
  const [productSheetGroup, setProductSheetGroup] =
    useState<ProductSheetGroup | null>(null)

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const eventTypeData = EventTypesSchema.safeParse(event.data.type)

      if (
        event.origin !== import.meta.env.VITE_BASE_FRONT_END_URL ||
        !eventTypeData.success
      )
        return

      const resolver = {
        STYLE_DATA: (payload: StylingParameters) => setStyleData(payload),
        CONFIGURATION_DATA: (payload: ScopedConfigurationsResponse) =>
          setConfiguration(payload),
        PRODUCT_SHEET_GROUP: (payload: ProductSheetGroup) =>
          setProductSheetGroup(payload),
      } as const

      resolver[eventTypeData.data](event.data.payload)
    }
    window.addEventListener("message", handleMessage)

    window.parent.postMessage({ type: "IFRAME_READY" }, "*")

    return () => window.removeEventListener("message", handleMessage)
  }, [])

  if (!styleData || !configuration || !productSheetGroup || !slug)
    return <Loader fullPage />

  const { logoFile } =
    DesignStudioParametersToolkit.spreadContentFilteringConfiguration(
      configuration
    )

  return (
    <>
      <SearchEngine
        stylingParameters={styleData}
        slug={slug}
        logoUrl={logoFile?.url ?? null}
        language={i18n.language}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
      />
    </>
  )
}
